/**
 * @generated SignedSource<<862b684d0a18b549d99b38a361b4af21>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JobApplicationDialog_User$data = {
  readonly " $fragmentSpreads": FragmentRefs<"JobSpecConfirmationDialog_User" | "useJobApplication_User" | "user_useIsClient" | "user_useIsMember">;
  readonly " $fragmentType": "JobApplicationDialog_User";
};
export type JobApplicationDialog_User$key = {
  readonly " $data"?: JobApplicationDialog_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"JobApplicationDialog_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobApplicationDialog_User",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useJobApplication_User"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "JobSpecConfirmationDialog_User"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "user_useIsMember"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "user_useIsClient"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "5f9dab5e4737193b538ea100e9dd533f";

export default node;
